module.exports = __webpack_public_path__ + "img/bg1.f74bc3ef.png";